export const BOOKING_FEE_REFUND_TEST_NAME = 'booking_fee_refundable_test_20220601_atl4400';
export const BOOKING_FEE_REFUND_TEST_PERCENT = 0.5;

export const COM_877_TEST_NAME = 'client_appointment_detail_com877_test_20220804';
export const COM_877_TEST_PERCENT = 0.5;

export enum SurveyQuestions {
  Rescheduled = 'I already rescheduled',
  NotAvailable = 'My stylist or I are no longer available',
  DifferentService = 'I need to book a different service with this stylist',
  DifferentStylist = 'The stylist didn’t meet my needs',
  Other = 'Other',
}

export enum ModalId {
  AutoCheckout = 'auto-checkout-opt-in-modal',
  AppointmentIntakeFormV1 = 'appointment-intake-form-v1',
  AppointmentIntakeForm = 'appointment-intake-form',
  RateThisApp = 'rate-this-app-modal',
}
